import { createContext } from 'react';
import { IUser } from 'models/auth';
import { IClassData } from '../models/icardio';

export const defaultUser: IUser = {
  token: '',
  profile: {
    email: '',
    firstName: '',
    lastName: '',
    isSuperuser: false,
  },
};

export const UserContext = createContext<{
  user: IUser;
  setUser: (user: IUser) => void;
}>({
  user: defaultUser,
  setUser: () => {},
});

export const ProfileContext = createContext<{
  selectedProfile: IUser;
  setSelectedProfile: (user: IUser) => void;
}>({
  selectedProfile: defaultUser,
  setSelectedProfile: () => {},
});

export const ReviewModeContext = createContext<{
  isReviewMode: boolean;
  setIsReviewMode: (isReviewMode: boolean) => void;
}>({
  isReviewMode: false,
  setIsReviewMode: () => {},
});

export const defaultClassData: IClassData = {
  viewClasses: [],
  phaseClasses: [],
  keypointCollectionClasses: [],
  segmentationClasses: [],
};

export const ClassDataContext = createContext<{
  classData: IClassData;
  setClassData: (classData: IClassData) => void;
}>({
  classData: defaultClassData,
  setClassData: () => {},
});
